import { IsDefined, Validate } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class ContractMarketDataService extends DataService<typeof Model.Products.Logic.ViewModels.ContractMarketItem, Model.Products.Logic.ViewModels.ContractMarketItem, ContractMarketItem> {
	protected map(entity: Model.Products.Logic.ViewModels.ContractMarketItem): ContractMarketItem {
		return new ContractMarketItemModel(entity);
	}

	private id = -1;
	public static make(ctx?: any): ContractMarketDataService {
		return new ContractMarketDataService(ctx, ctx => ctx.ContractMarkets);
	}

	add(idContract: number) {
		const entity = new Model.Products.Logic.ViewModels.ContractMarketItem();
		entity.contractId = idContract;
		entity.id = this.id--;

		return entity;
	}

	clone(contractMarketItem: ContractMarketItem) {
		const entity = new Model.Products.Logic.ViewModels.ContractMarketItem();
		entity.contractId = contractMarketItem.contractId;
		entity.marketId = contractMarketItem.marketId;
		entity.marketName = contractMarketItem.marketName;
		entity.marketCurrencyId = contractMarketItem.marketCurrencyId;
		entity.marketDefaultMargin = contractMarketItem.marketDefaultMargin.toString();
		entity.marketMarginPolicy = contractMarketItem.marketMarginPolicy;
		entity.marketMarketPriceType = contractMarketItem.marketMarketPriceType;
		entity.id = (contractMarketItem.id > 0) ? contractMarketItem.id * -1 : contractMarketItem.id - 100;

		return entity;
	}
}

export class ContractMarketItemModel extends EntityModel<Model.Products.Logic.ViewModels.ContractMarketItem, ContractMarketItem> implements ContractMarketItem {
	@property<ContractMarketItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<ContractMarketItemModel>(o => o.entity.contractId, (o, value) => o.entity.contractId = value)
	public contractId: number;
	@IsDefined({ message: 'market is required' })
	@property<ContractMarketItemModel>(o => o.entity.marketId, (o, value) => o.entity.marketId = value)
	public marketId: number;

	@property<ContractMarketItemModel>(o => o.entity.marketName, (o, value) => o.entity.marketName = value)
	public marketName: string;

	@property<ContractMarketItemModel>(o => o.entity.marketCurrencyId, (o, value) => o.entity.marketCurrencyId = value)
	public marketCurrencyId: number;

	@property<ContractMarketItemModel>(o => o.entity.marketDefaultMargin, (o, value) => o.entity.marketDefaultMargin = value)
	public marketDefaultMargin: number;

	@property<ContractMarketItemModel>(o => o.entity.marketMarginPolicy, (o, value) => o.entity.marketMarginPolicy = value)
	public marketMarginPolicy: number;

	@property<ContractMarketItemModel>(o => o.entity.marketMarketPriceType, (o, value) => o.entity.marketMarketPriceType = value)
	public marketMarketPriceType: number;
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/contract-market-form.data.ts